export const USER_ROLES_SLICE_NAME = '@@userRoles';
